import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import * as XLSX from "xlsx";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
//import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
//import DialogContentText from "@material-ui/core/DialogContentText";
import { Accordion,
  AccordionSummary,
  AccordionDetails,Typography } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import { getCourseVotes,getSessionInfo,createCourse } from "../firebaseApi";

const styles = (theme) => ({});

/*
 * DATA FORMAT:
 *
 * data = [
 *   {
 *     categories: [
 *       'category1',
 *        ...
 *     ],
 *     sessions: [
 *       #, // Number of polls for session 1
 *        ...
 *     ]
 *   },
 *   {
 *     studentFirstName: 'studentFirstName',
 *     studentLastName: 'studentLastName',
 *     studentID: 'studentID',
 *     identifer: 'identifier',
 *     iClicker: 'iClicker',
 *     studentCategories: [
 *       'optionA' // Option chosen for category1
 *        ...
 *     ],
 *     studentVotes: [
 *       'A',
 *        ...
 *     ],
 *   },
 *    ...
 * ]
 */


class InstructorCourseExportSelect extends Component {
  constructor(props){
    super(props);
    getSessionInfo(this.props.course.courseID).then(data=>{
      if(this.state.data.includedSessions === false){
        let includedSesh = Array(data[0].sessions.length).fill(true);
        const newData = this.state.data
        newData.includedSessions = includedSesh
        this.setState({
          data:newData
        })
      }
      this.setState({
        checkboxes: Array.from({ length: data[0].sessions.length }, (_, i) => ({
        label: `Session ${i + 1} - `  + data[0].dates[i] + " | " + data[0].sessions[i] + " polls",
        checked: this.state.data.includedSessions[i] ?? true,
        merged:false,
        sub_checkbox: Array.from({ length: data[0].polls[i].length }, (_, j) => ({
          label: `Poll ${j + 1} - `  + data[0].polls[i][j] + " votes",
          checked: this.state.data.includedSessions[i] ?? true,
          }))
        })),
        
      })
    })
    
  }
  state = {
    exporting: false,
    showLoadingIndicator: false,
    checkboxes:[],
    data:{
      courseID: this.props.course?.courseID || 'N/A',
      courseName: this.props.course?.courseName || '',
      courseTerm: this.props.course?.courseTerm || '',
      courseCode: this.props.course?.courseCode || '',
      courseCategories: this.props.course?.courseCategories || [],
      modifiedCategories: this.props.course?.modifiedCategories || [],
      courseInstructorID: this.props.course?.courseInstructorID || '',
      isActive: this.props.course?.isActive || false,
      iClickerEn: this.props.course?.iClickerEn || false,
      iClickerFreq: this.props.course?.iClickerFreq || '',
      anonVoteEn: this.props.course?.anonVoteEn || false,
      // forcePID: this.props.course?.forcePID || false,
      restrictDomain: this.props.course?.restrictDomain || false,
      restrictDomainEmail: this.props.course?.restrictDomainEmail || "",
      restrictDomainOverride: this.props.course?.restrictDomainOverride || "",
      geofencing: this.props.course?.geofencing || false,
      geoDistance: this.props.course?.geoDistance || 0,
      screenshotsEn: this.props.course?.screenshotsEn || false,
      screenshotDevice: this.props.course?.screenshotDevice || null,
      docLink: this.props.course?.docLink || "",
      coInstructors: this.props.course?.coInstructors || [],
      studentPollHistory: this.props.course?.studentPollHistory || false,
      // tutors: this.props.course?.tutors || [],
      tas: this.props.course?.tas || [],
      includedSessions:this.props.course?.includedSessions || false,
      chooseCategories: this.props.course?.chooseCategories || [],
      googleDriveFolderID: this.props.course?.googleDriveFolderID || "",
      lockedPolls: this.props.course?.lockedPolls || false,
    }
      
  };

  exportVotes(sessionsIncluded,pollsIncluded,pollsMerged) {
    this.setState({ exporting: true, showLoadingIndicator: true });
    
    getCourseVotes(this.props.course.courseID)
      .then((data) => {
        //console.log(data);
        let csvData = [];
        let categNum = 0;
        // Populate first row of csv
        csvData.push([]);
        csvData[0].push("Email");
        csvData[0].push("Last Name");
        csvData[0].push("First Name");
        // csvData[0].push("Student Identifier");
        this.props.course.iClickerEn && csvData[0].push("iClicker ID");
        data[0].categories.forEach((category) => {
          categNum++;
          csvData[0].push(category);
        });
        let sessionCount = 1;
        let includedIndex = 1;
        let sessionsForPolls = []
        let pollInSessions = []
        let pollsIncludedData = []
        data[0].sessions.forEach((numPolls) => {
          
          pollInSessions.push(numPolls);
          if (numPolls !== 0 && sessionsIncluded[sessionCount - includedIndex]) {
            if(!pollsMerged[sessionCount - includedIndex]){
              csvData[0].push("Session " + sessionCount);
            }else{
              csvData[0].push(undefined);
            }
            sessionsForPolls.push(true);
            pollsIncludedData.push(pollsIncluded[sessionCount-includedIndex])
            
          }else if(numPolls !== 0 && !sessionsIncluded[sessionCount - includedIndex]){
            sessionsForPolls.push(false)
            pollsIncludedData.push([])
          }
          
          let doneOnce = false;
          for (let i = 0; i < numPolls; i++) {
            if(doneOnce && sessionsIncluded[sessionCount - includedIndex] && pollsIncluded[sessionCount-includedIndex][i]){
              csvData[0].push(undefined);
            }else if(sessionsIncluded[sessionCount - includedIndex] && pollsIncluded[sessionCount-includedIndex][i]){
              doneOnce = true;
            }
          }
          if(numPolls === 0){
            includedIndex++;
            sessionsForPolls.push(false);
            pollsIncludedData.push([])
          }
          sessionCount++;
        });
        csvData[0].push("Score")
        csvData[0].push("Percentage")
        // Populate second row of csv
        csvData.push([]);
        // Blank for student info
        for (let i = 0; i < 3 + data[0].categories.length; i++) {
          csvData[1].push(undefined);
        }
        // Poll# for each session
        sessionCount = 0;
        data[0].sessions.forEach((numPolls) => {
          if(sessionsForPolls[sessionCount]){
            for (let i = 1; i <= numPolls; i++) {
              if(pollsIncludedData[sessionCount][i-1])
                csvData[1].push("Poll " + i);
            }
          }
          sessionCount++;
        });

        // Populate each student row of csv
        for (let i = 1; i < data.length-5; i++) {
          let student = data[i];
          csvData.push([]);

          // Student name and ID
          csvData[i + 1].push(student.studentID);
          csvData[i + 1].push(student.studentLastName);
          csvData[i + 1].push(student.studentFirstName);
          // csvData[i + 1].push(student.identifier);
          this.props.course.iClickerEn && csvData[i + 1].push(student.iClicker);

          // Student categories
          student.studentCategories.forEach((category) => {
            if (category === undefined) {
              csvData[i + 1].push("Unknown");
            } else {
              csvData[i + 1].push(category);
            }
          });

          // Student votes TODO: only include votes included by sessions
          //currently breaks if the first few sessions have 0 polls, fix
          let voteIndex = 0;
          let smallIndex = 0;
          let score = 0;
          let total = 0;
          let j = 0;
          student.studentVotes.forEach((vote) => {
            if(sessionsForPolls[voteIndex] || pollInSessions[voteIndex] === 0){
              if(pollInSessions[voteIndex] === 0){
                smallIndex--;
              }
              
              if(pollsIncludedData[voteIndex][smallIndex]){
                total++;
                if (vote === undefined) {
                  csvData[i + 1].push(undefined);
                }  else {
                  if(this.props.correctOnly){
                    if(vote.includes(data[0].answers[j]) || data[0].answers[j] === undefined){
                      csvData[i + 1].push(vote);
                      score++;
                    }else{
                      csvData[i + 1].push(undefined);
                    }
    
                  }
                  else if(vote.includes("X")){
                    csvData[i+1].push("X")
                    score++;
                  }else{
                    csvData[i + 1].push(vote);
                    score++;
                  }
                }
                j++;
              }
           }
            smallIndex++;
            if(smallIndex === pollInSessions[voteIndex]){
                voteIndex++;
                smallIndex = 0;
            }
          });
          //csvData[i+1].push(score + '/' + total)
        }
        if(this.props.anonVotes){
        for(let i = data.length-5; i < data.length; i++){
          let anon = data[i];
          csvData.push([])
          csvData[i+1].push("Anonymous Votes " + anon.studentID)
          for(let j = 0; j < categNum+2;j++){
            csvData[i+1].push(undefined);
          }
          anon.studentVotes.forEach((vote) => {
            csvData[i+1].push(vote)
          });
        }
      }
        // Generate .csv file
        let wb = XLSX.utils.book_new();
        let ws = XLSX.utils.aoa_to_sheet(csvData);
        let name = this.props.course.courseName.slice(0,25) + " Votes";
        XLSX.utils.book_append_sheet(wb, ws, name);
        XLSX.writeFile(wb, name + ".csv");

        this.setState({ exporting: false, showLoadingIndicator: false });
        this.props.openCtl(false);
      })
      .catch((err) => {
        // console.log(err);
        this.setState({ exporting: false, showLoadingIndicator: false });
        this.props.openCtl(false);
      });
  }
  handleChange = (index,check) => {
    const updateItems = [...this.state.checkboxes]
    let included = this.state.data.includedSessions
    const updateData = {...this.state.data,includedSessions:included}
    included[index] = !check;
    for(let i = 0; i < updateItems[index].sub_checkbox.length; i++){
      this.handleSubChange(i,check,index)
    }
    updateItems[index] ={
      ...updateItems[index],
      checked: !check
    }
    this.setState({
      checkboxes:updateItems,
      data:updateData
    })
    //console.log(this.state.data.includedSessions)
  };
  handleMerge = (index,check) => {
    const updateItems = [...this.state.checkboxes]
    updateItems[index] ={
      ...updateItems[index],
      merged: !check
    }
    this.setState({
      checkboxes:updateItems,
    })
    //console.log(this.state.data.includedSessions)
  };
  handleSubChange = (index1,check,index) => {
    //console.log("updated child")
    const updateItems = [...this.state.checkboxes]
    updateItems[index].sub_checkbox[index1] ={
      ...updateItems[index].sub_checkbox[index1],
      checked:!check,
    }
    this.setState({
      checkboxes:updateItems
    })
  };
  render() {
    let mobile = this.props.width === "sm" || this.props.width === "xs";
    const { exporting, showLoadingIndicator } = this.state;

    return (
      <Dialog 
        fullScreen={mobile}
        fullWidth
        maxWidth="sm"
        open={this.props.open}
        onClose={() => {
          this.props.openCtl(false);
        }}
      >
        <DialogTitle style = {{backgroundColor:"white", zIndex:"10"}}>{"Export " + this.props.course.courseName}</DialogTitle>
         <FormGroup >
              {this.state.checkboxes.map((checkbox, index) => (
        <Accordion key={"accordian" + index} >
          <AccordionSummary 
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
             <Typography className={"Session 1"}>
                
                <FormControlLabel
                  key={index}
                  onClick={(e)=>{e.stopPropagation();}} //stops the accordian from being annoying
                  control={
                <Checkbox
                    checked={checkbox.checked}
                    onChange={(e)=>{
                      
                      this.handleChange(index,checkbox.checked)
                    }}
                    name={`checkbox-${index}`}
                  />
              }
              label={checkbox.label}
              />
              
              
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
          <FormGroup>
          {index !== 0 ? <FormControlLabel
          key={"merger"}
          style = {{marginLeft:"2rem"}}
          control={
            <Checkbox
                checked={checkbox.merged}
                onChange={(e)=>{
                  console.log("Merge")
                  this.handleMerge(index,checkbox.merged)
                }}
                name={`sub_checkbox-${index}`}
              />
          }
          label={"Merge Session with previous"}
          />  : null}
          {checkbox.sub_checkbox.map((sub_check, index1) => (
          <FormControlLabel
          key={index1}
          style = {{marginLeft:"2rem"}}
          control={
            <Checkbox
                checked={sub_check.checked}
                onChange={(e)=>{
                  this.handleSubChange(index1,sub_check.checked,index)
                }}
                name={`sub_checkbox-${index}`}
              />
          }
          label={sub_check.label}
          />
            
            ))}
          </FormGroup>
          </AccordionDetails>
        </Accordion>
        ))}
            </FormGroup>
       
        <DialogActions >
          <Button
            color="primary"
            onClick={() => {
              this.props.openCtl(false);
            }}
          >
            Cancel
          </Button>

          <Button
            color="primary"
            onClick={() => {
              this.setState({ showLoadingIndicator: true }, () => {
                let sessionsIncluded = Array(this.state.checkboxes.length)
                let pollsIncluded = []
                let pollsMerged= [];
                let i = 0;
                for(let checkbox of this.state.checkboxes){
                  let singleSesh = []
                  for(let poll of checkbox.sub_checkbox){
                    singleSesh.push(poll.checked)
                  }
                  sessionsIncluded[i] = checkbox.checked;
                  pollsIncluded.push(singleSesh)
                  pollsMerged[i] = checkbox.merged
                  i++;
                }
                createCourse(this.state.data)
                this.exportVotes(sessionsIncluded,pollsIncluded,pollsMerged)
              });
            }}
            disabled={exporting}
          >
            Export
          </Button>
        </DialogActions>
        {showLoadingIndicator && <LinearProgress />}
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(InstructorCourseExportSelect))
  )
);
